/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AsCodeMonitorDto } from '../models/AsCodeMonitorDto';
import type { AsCodeWorkspaceDto } from '../models/AsCodeWorkspaceDto';
import type { LightWorkspaceApplyRequestDto } from '../models/LightWorkspaceApplyRequestDto';
import type { PatchWorkspaceDto } from '../models/PatchWorkspaceDto';
import type { RuleDto } from '../models/RuleDto';
import type { SearchCollectionWorkspaceDto } from '../models/SearchCollectionWorkspaceDto';
import type { WorkspaceApplyResponseDto } from '../models/WorkspaceApplyResponseDto';
import type { WorkspaceDto } from '../models/WorkspaceDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkspaceService {

    /**
     * Convert a monitor definition to it's as-code equivalent
     * @returns AsCodeMonitorDto Successfully converted monitor
     * @throws ApiError
     */
    public static convertMonitorToCode({
        requestBody,
        mode = 'RELAXED',
    }: {
        requestBody: RuleDto,
        mode?: 'RELAXED' | 'STRICT' | 'EXPANDED',
    }): CancelablePromise<AsCodeMonitorDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rules/_convert-to-code',
            query: {
                'mode': mode,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                426: `Upgrade Required`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get all workspaces
     * @returns SearchCollectionWorkspaceDto Successfully fetch workspaces
     * @throws ApiError
     */
    public static getAllWorkspaces(): CancelablePromise<SearchCollectionWorkspaceDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/workspaces',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete workspace
     * @returns void
     * @throws ApiError
     */
    public static forceDeleteWorkspaceWithCascadeAll({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/ui/v1/workspaces/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Patch workspace
     * @returns WorkspaceDto Patch a workspace
     * @throws ApiError
     */
    public static patchWorkspace({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: PatchWorkspaceDto,
    }): CancelablePromise<WorkspaceDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/ui/v1/workspaces/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Convert all monitors to as-code
     * Fetches monitors, converts each to its as-code representation, and returns them in a paginated list.
     * @returns AsCodeMonitorDto Successfully converted monitors to as-code
     * @throws ApiError
     */
    public static getAllMonitorsAsCode({
        mode = 'RELAXED',
        textSearch,
        ruleTemplateName,
        lastRunStatus,
        ruleStatus,
        dataset,
        tag,
        datasource,
        criticality,
        domain,
        page,
        itemsPerPage = 25,
        sort,
    }: {
        mode?: 'RELAXED' | 'STRICT' | 'EXPANDED',
        /**
         * Global text search
         */
        textSearch?: string,
        /**
         * Filter on given rule template name
         */
        ruleTemplateName?: Array<string>,
        /**
         * Filter on given last run statuses
         * @deprecated
         */
        lastRunStatus?: Array<'PENDING' | 'RUNNING' | 'SUCCESS' | 'REQUIRES_YOUR_ATTENTION' | 'TECHNICAL_ERROR' | 'FAILED'>,
        /**
         * Filter on given rule status
         */
        ruleStatus?: Array<'NOT_EVALUATED' | 'PASSING' | 'NEEDS_ATTENTION' | 'FAILING'>,
        /**
         * Filter on given dataset ids
         */
        dataset?: Array<string>,
        /**
         * Filter on given tag ids
         */
        tag?: Array<string>,
        /**
         * Filter on given datasource ids
         */
        datasource?: Array<string>,
        criticality?: Array<number>,
        /**
         * Domain searched
         */
        domain?: string,
        /**
         * The requested page number. Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The number of elements to be returned inside the page. Pass a value of -1, to bypass pagination and fetch all items
         */
        itemsPerPage?: number,
        /**
         * The resource fields on which to apply the sort, format : property,ASC|DESC
         */
        sort?: Array<string>,
    }): CancelablePromise<Array<AsCodeMonitorDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/rules/_all-as-code',
            query: {
                'mode': mode,
                'textSearch': textSearch,
                'ruleTemplateName': ruleTemplateName,
                'lastRunStatus': lastRunStatus,
                'ruleStatus': ruleStatus,
                'dataset': dataset,
                'tag': tag,
                'datasource': datasource,
                'criticality': criticality,
                'domain': domain,
                'page': page,
                'itemsPerPage': itemsPerPage,
                'sort': sort,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * List workspaces
     * @returns AsCodeWorkspaceDto Successfully fetch workspaces
     * @throws ApiError
     */
    public static listWorkspaces(): CancelablePromise<Array<AsCodeWorkspaceDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/workspaces',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete workspace
     * @returns WorkspaceApplyResponseDto Successfully delete workspace
     * @throws ApiError
     */
    public static deleteWorkspace({
        id,
        cascadeDelete = 'ALL',
        dryRun = false,
    }: {
        id: string,
        cascadeDelete?: 'ALL' | 'MONITORS' | 'NONE',
        dryRun?: boolean,
    }): CancelablePromise<WorkspaceApplyResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/workspaces/{id}',
            path: {
                'id': id,
            },
            query: {
                'cascadeDelete': cascadeDelete,
                'dryRun': dryRun,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Apply workspace
     * @returns WorkspaceApplyResponseDto Successfully apply workspace state
     * @throws ApiError
     */
    public static deployWorkspace({
        id,
        requestBody,
        errorAction = 'ERROR',
        objectTrackAction = 'ERROR',
        objectMoveAction = 'ERROR',
        objectUntrackAction = 'ERROR',
        dryRun = false,
    }: {
        id: string,
        requestBody: LightWorkspaceApplyRequestDto,
        errorAction?: 'ERROR' | 'FATAL',
        objectTrackAction?: 'ERROR' | 'IGNORE' | 'TRACK',
        objectMoveAction?: 'ERROR' | 'IGNORE' | 'MOVE',
        objectUntrackAction?: 'ERROR' | 'IGNORE' | 'UNTRACK' | 'DELETE',
        dryRun?: boolean,
    }): CancelablePromise<WorkspaceApplyResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/workspaces/{id}',
            path: {
                'id': id,
            },
            query: {
                'errorAction': errorAction,
                'objectTrackAction': objectTrackAction,
                'objectMoveAction': objectMoveAction,
                'objectUntrackAction': objectUntrackAction,
                'dryRun': dryRun,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Download workspace code
     * @returns binary Successfully downloaded code
     * @throws ApiError
     */
    public static downloadWorkspaceCode({
        id,
    }: {
        id: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/workspaces/{id}/_download',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
